// JD-list helpers: the list-item shape the backend returns plus a display
// label for where the posting came from. Status/labels are shared with
// resumes (same lifecycle).

import type { ResumeJobStatus } from "@agp/shared";

export interface JdListItem {
  id: string;
  status: ResumeJobStatus;
  sourceKind: "paste" | "file" | "url";
  sourceFilename: string | null;
  sourceUrl: string | null;
  title: string | null;
  company: string | null;
  error: string | null;
  candidateOwner: string | null;
  outputCount: number;
  ownerEmail: string;
  createdAt: string;
  updatedAt: string;
}

export function jdSourceLabel(jd: Pick<JdListItem, "sourceKind" | "sourceFilename" | "sourceUrl">): string {
  if (jd.sourceKind === "paste") return "Pasted text";
  if (jd.sourceKind === "url") {
    try {
      return new URL(jd.sourceUrl ?? "").hostname;
    } catch {
      return jd.sourceUrl ?? "Link";
    }
  }
  return jd.sourceFilename ?? "File";
}
